import styled from 'styled-components';

export const StyContainer = styled.div`
  width: 100%;
`;

export const StyTableOuter = styled.div`
  overflow-x: hidden;
`;

export const StyTableWrapper = styled.div`
  overflow-y: auto;
`;

export const StyTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const StyThead = styled.thead`
  background-color: ${({ theme }) => theme.neutral900};
  z-index: 10;
  color: ${({ theme }) => theme.neutral400};

  > th:first-of-type {
    padding-left: 10px;
  }
`;

export const StyTh = styled.th<{ minWidth?: string | number }>`
  text-align: left;
  padding: 10px 0px;
  font-weight: 500;
  width: ${({ minWidth }) =>
    minWidth !== undefined
      ? typeof minWidth === 'number'
        ? `${minWidth}px`
        : minWidth
      : 'auto'};
`;

export const StyTd = styled.td<{ minWidth?: string | number }>`
  padding: 10px 0px;
  width: ${({ minWidth }) =>
    minWidth !== undefined
      ? typeof minWidth === 'number'
        ? `${minWidth}px`
        : minWidth
      : 'auto'};
  color: ${({ theme }) => theme.neutral600};
`;

export const StyTr = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.neutral700};
  &:last-child {
    border: none;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
